import React from 'react';
import Modal from 'react-modal';
import '../../styles/CustomModal.css';
import 'react-responsive-modal/styles.css';
import { langText } from '../../recoil/lang';
import styled from 'styled-components';

interface ModalProps {
  isOpen: boolean;
  onCancel: () => void;
  onSuccess?: any;
  lang: number;
}

const OrderCancelModal: React.FC<ModalProps> = ({ isOpen, onCancel, onSuccess, lang }) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onCancel}
      className="bottom-modal"
      closeTimeoutMS={100}
      ariaHideApp={false}
      style={{
        overlay: {
          height: '100vh',
          display: 'flex',
          alignItems: 'flex-end',
          bottom: '0',
        },
      }}>
      <Style>
        <div className="alertModalWrap">
          <div className="modalContentWrap">
            <img
              onClick={onCancel}
              className="closeIcon"
              src={`${process.env.PUBLIC_URL}/svg/ic_close.svg`}
              alt="닫기 아이콘"
            />
            <img src={`${process.env.PUBLIC_URL}/svg/status_cancel2.svg`} alt="취소 아이콘" />
            <h2>{langText.cancel_modal_title[lang]}</h2>
            <p>{langText.cancel_modal_content[lang]}</p>
            <button onClick={onSuccess}>{langText.cancel_success_button[lang]}</button>
          </div>
        </div>
      </Style>
    </Modal>
  );
};

export default OrderCancelModal;
const Style = styled.div`
  h2 {
    margin: 10px 0 24px 0;
    font-size: 20px;
    font-weight: 600;
    color: #555;
  }
  p {
    font-size: 1rem;
    font-weight: 500;
    color: #999;
    line-height: 25px;
    white-space: pre;
  }

  .modalContentWrap {
    width: 100vw;
    height: 55vh;
    position: relative;
    padding: 40px 15px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    background: #fff;
    border-top-right-radius: 20px;
    border-top-left-radius: 20px;
    padding-bottom: 100px;

    button {
      width: 100%;
      margin-top: 36px;
      padding: 11px 0;
      background: #ff6060;
      color: #fff;
      font-size: 20px;
      font-weight: 600;
      border-radius: 10px;
    }
  }
  .closeIcon {
    position: absolute;
    right: 10px;
    top: 10px;
  }
`;
